import constants from "./constants";
import {
  adminRoutes,
  portPlannerRoutes,
  plannerRoutes,
  plannerVoidRoutes,
  clientRoutes,
  executiveRoutes,
  supervisorVoidsRoutes,
  MovementSupervisorRoutes,
  MechRoutes,
  MaintenancePlannerRoutes,
  AdministrativeRoutes,
  FuelProviderRoutes,
  ProviderRoutes,
  CCTV,
  accountExecutiveRoutes
} from "./constants/routes";

import store from "./store";

let user = store.getters["user/user"];
let items = [];

if (user) {
  switch (user.role.code) {
    case constants.ADMIN:
      items = adminRoutes;
      break;
    case constants.ADMINISTRATIVO:
      items = AdministrativeRoutes;
      break;
    case constants.PLANIFICADOR:
      items = plannerRoutes;
      break;
    case constants.PLANIFICADOR_VACIOS:
      items = plannerVoidRoutes;
      break;
    case constants.PLANIFICADOR_PORTEO:
      items = portPlannerRoutes;
      break;
    case constants.SOLICITANTE:
      items = clientRoutes;
      break;
    case constants.EJECUTIVO_COMERCIAL:
      items = executiveRoutes;
      break;
    case constants.SUPERVISOR_VACIOS:
      items = supervisorVoidsRoutes;
      break;
    case constants.SUPERVISOR_MOVIMIENTOS_INTERNOS:
      items = MovementSupervisorRoutes;
      break;
    case constants.MECANICO:
      items = MechRoutes;
      break;
    case constants.PLANIFICADOR_MANTENIMIENTO:
      items = MaintenancePlannerRoutes;
      break;
    case constants.ABASTECEDOR:
      items = FuelProviderRoutes;
      break;
    case constants.PROVEEDOR:
      items = ProviderRoutes;
      break;
    case constants.CCTV:
      items = CCTV;
      break;
    case constants.EJECUTIVO_CUENTA:
      items = accountExecutiveRoutes;
      break;
  }
}

export default {
  items
};
